import { Database, get, query, QueryConstraint, ref } from '@angular/fire/database';

/**
 * Get data from database DIRECTLY
 * @warning ONLY FOR RESOLVERS
 */
export class DirectDbAccessService {
  /**
   * Get current object snapshot from database
   * @param {string}            path
   * @param {Database}          dbRef       Reference to ROOT NODE of database
   * @param {QueryConstraint[]} constraints query constraints in array, eg. orderByChild, equalTo, orderByKey, etc.
   * @return {Promise<T | null>} Current object snapshot (or null, if not exist)
   */
  public static async onceObject<T>(path: string, dbRef: Database, constraints?: QueryConstraint[]): Promise<T | null> {
    return (await get(query(ref(dbRef, path), ...(constraints ?? [])))).val();
  }

  /**
   * Get current object list snapshot from database
   * @param {string}            path
   * @param {Database}          dbRef       Reference to ROOT NODE of database
   * @param {QueryConstraint[]} constraints query constraints in array, eg. orderByChild, equalTo, orderByKey, etc.
   * @return {Promise<T[]>} Current array snapshot (or empty if not exist)
   */
  public static async onceList<T>(path: string, dbRef: Database, constraints?: QueryConstraint[]): Promise<T[]> {
    return Object.values((await get(query(ref(dbRef, path), ...(constraints ?? [])))).val() ?? []);
  }
}
